import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['inputElement']

  onChange(event) {
    this.inputElementTargets.forEach(inputElement => {
      inputElement.disabled = !(inputElement.dataset.enableValue.split(',').indexOf(event.currentTarget.value) > -1)
    })
  }
}
